export interface IHistoryMapper<T> {
  localeDate: string;
  collapse:boolean;
  children: T[]
}
export class HistoryMapper<T> implements IHistoryMapper<T> {
  localeDate: string;
  collapse:boolean;
  children: T[]
  /**
   *
   */
  constructor(dateString: string, children: T[]) {
    this.localeDate = dateString;
    this.collapse = false;
    this.children = children;
  }
}